const ProductImage = {
    product1: require('../img/product/product1.png'),
    product2: require('../img/product/product2.png'),
    product3: require('../img/product/product3.png'),
    product4: require('../img/product/product4.png'),
    product5: require('../img/product/product5.png'),
    product6: require('../img/product/product6.png'),
    product7: require('../img/product/product7.png'),
    product8: require('../img/product/product8.png'),
    product9: require('../img/product/product9.png'),
    product10: require('../img/product/product10.png'),
    product11: require('../img/product/product11.png'),
    product12: require('../img/product/product12.png'),
    product13: require('../img/product/product13.png'),
    product14: require('../img/product/product14.png'),
    product15: require('../img/product/product15.png'),
    product16: require('../img/product/product16.png'),
    product17: require('../img/product/product17.png'),
    product18: require('../img/product/product18.png'),
    product19: require('../img/product/product19.png'),
    product20: require('../img/product/product20.png'),
    product21: require('../img/product/product21.png'),
    product22: require('../img/product/product22.png'),
    product23: require('../img/product/product23.png'),
    product24: require('../img/product/product24.png'),
    product25: require('../img/product/product25.png'),
    product26: require('../img/product/product26.png'),
    product27: require('../img/product/product27.png'),
}
export default ProductImage;